import { areProcessStepsEquals } from "./areProcessStepEquals";
import { collectDuplicateIds } from "./findDuplicateMaterials";

type ProcessStepForDuplicateCheck = {
  id: string;
  industrialProcess: string;
  type: string;
  machineName: string | null;
};

export const findDuplicateProcessStepIds = (
  processSteps: ProcessStepForDuplicateCheck[],
): string[] =>
  collectDuplicateIds(
    processSteps,
    (a, b) =>
      a.type === b.type &&
      areProcessStepsEquals(
        { industrialProcess: a.industrialProcess, description: a.machineName },
        { industrialProcess: b.industrialProcess, description: b.machineName },
      ),
    (processStep) => processStep.id,
  );
